import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { OzonProductList } from 'src/app/models';
import { ApiOzonProductListService } from 'src/app/services/integrations/ozon/api-ozon-product-list.service';

@Component({
  selector: 'app-ozon-product-profile',
  templateUrl: './ozon-product-profile.component.html',
  styleUrls: ['./ozon-product-profile.component.css']
})
export class OzonProductProfileComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  profileData: OzonProductList;
  listId: string;

  @Input() set data(value) {

    if (value != null) {

      this.listId = value.id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private apiOzonService: ApiOzonProductListService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getProductInfo();

  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   * @param file
   */
   getProductInfo(): void {

    this.profileData = null;
    this.loading = true;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOzonService.getInfo(this.listId).subscribe(response => {
        console.log("[RESPONSE] getProfileInfo: ", response);

        if (response != null) {

          this.profileData = response.result;

        }

        this.loading = false;
        this.progressRef.complete();
      })
    );
  }

  // onEdit(){
    
  //   this.router.navigate(['products', 'edit', this.listData.product_id]);
  //   this.activeModal.close(true);
    
  // }

}
